import Vue from "vue";
import VueRouter from "vue-router";
import LoginComponent from "../views/login.vue";
import MenuComponent from "../views/Menu.vue";
import PlatosMenuComponent from "../views/PlatosMenu.vue";
import GruposComponent from "../views/Grupos.vue";
import ArticulosComponent from "../views/Articulos.vue";
import HomeComponent from "../views/Home.vue";
import RestauranteComponent from "../views/Restaurante.vue";
import MspAccessComponent from "../views/MspAccess.vue";

Vue.use(VueRouter);

const routes = [
  { path: '/msp-access', name: 'MspAccess', component: MspAccessComponent },
  { path: "/Restaurante", name: "Restaurante", component: RestauranteComponent },
  {
    path: "/",
    redirect: {
      name: "login",
    },
  },
  {
    path: "/Home",
    name: "Home",
    component: HomeComponent,
  },
  {
    path: "/Articulos",
    name: "Articulos",
    component: ArticulosComponent,
  },
  {
    path: "/Menu",
    name: "Menu",
    component: MenuComponent,
  },
  {
    path: "/PlatosMenu",
    name: "PlatosMenu",
    component: PlatosMenuComponent,
  },
  {
    path: "/Grupos",
    name: "Grupos",
    component: GruposComponent,
  },
  {
    path: "/login",
    name: "login",
    component: LoginComponent,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
